import { TrendingUp, ListTodo, CheckCircle2, Flag } from "lucide-react";

export default function GlobalProgressSummary({ project, phases, activePhase }) {
  const progress = project?.progress || { global_percent: 0, total_tasks: 0, completed_tasks: 0 };
  const pending = progress.total_tasks - progress.completed_tasks;
  const milestone = activePhase?.critical_milestone;

  const budget = project?.budget
    ? new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(project.budget)
    : null;

  const stats = [
    { icon: ListTodo, label: "Pendientes", value: pending, testid: "stat-pending" },
    { icon: CheckCircle2, label: "Completadas", value: progress.completed_tasks, testid: "stat-completed" },
  ];

  return (
    <div className="rounded-2xl border border-border bg-card overflow-hidden" data-testid="global-progress-summary">
      <div className="p-6 sm:p-7">
        <div className="flex flex-wrap items-start justify-between gap-4">
          <div>
            <div className="caption mb-1.5">Estado de obra</div>
            <h2 className="text-2xl font-bold tracking-tight">{project?.name}</h2>
            <p className="text-sm text-muted-foreground mt-0.5">{project?.location}</p>
          </div>
          {budget && (
            <div className="text-right">
              <div className="caption mb-1">Presupuesto</div>
              <div className="font-mono text-xl font-semibold">{budget}</div>
              {project?.surface ? (
                <div className="text-xs text-muted-foreground font-mono">{project.surface} m²</div>
              ) : null}
            </div>
          )}
        </div>

        {/* Global progress */}
        <div className="mt-6">
          <div className="flex items-end justify-between mb-2">
            <span className="text-sm font-medium flex items-center gap-1.5">
              <TrendingUp className="h-4 w-4 text-primary" /> Avance global
            </span>
            <span className="font-mono text-3xl font-bold tracking-tight" data-testid="global-percent">
              {progress.global_percent}%
            </span>
          </div>
          <div className="h-3 rounded-full bg-secondary overflow-hidden" data-testid="phase-progress-bar-global">
            <div
              className="h-full bg-primary rounded-full transition-all duration-1000"
              style={{ width: `${progress.global_percent}%`, transitionTimingFunction: "cubic-bezier(0.16,1,0.3,1)" }}
            />
          </div>
        </div>

        <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 gap-4">
          {stats.map((s) => (
            <div key={s.label} className="rounded-xl bg-background-subtle border border-border/60 p-4" data-testid={s.testid}>
              <s.icon className="h-4 w-4 text-muted-foreground mb-2" />
              <div className="font-mono text-2xl font-bold">{s.value}</div>
              <div className="text-xs text-muted-foreground">{s.label}</div>
            </div>
          ))}
          {milestone && (
            <div className="rounded-xl bg-accent border border-border/60 p-4 col-span-2 sm:col-span-1" data-testid="stat-milestone">
              <Flag className="h-4 w-4 text-olive mb-2" />
              <div className="text-sm font-semibold leading-tight text-olive">{milestone}</div>
              <div className="text-xs text-muted-foreground mt-0.5">Próximo hito</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
